import React from 'react';
import { LoginForm } from '../components/Auth/LoginForm';
import { ThemeToggle } from '../components/ui/ThemeToggle';

export const AuthPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-surface flex flex-col md:grid md:grid-cols-2">
      {/* Editorial brand panel — navy in both modes */}
      <div className="bg-inverse text-ink-inverse flex flex-col justify-between p-8 md:p-14">
        <p className="label-caps text-accent">Universal booking platform</p>
        <div className="py-10 md:py-0">
          <h1 className="display text-5xl md:text-6xl leading-none">NexSlot</h1>
          <p className="text-slate-300 mt-6 max-w-sm leading-relaxed text-sm">
            Your services, your schedule, one link. Customers pick a slot,
            you get the booking — payments and confirmations included.
          </p>
        </div>
        <div className="hidden md:block">
          <div className="h-px bg-white/10 mb-4" />
          <p className="label-caps text-slate-400">Private beta · Invitation only</p>
        </div>
      </div>

      {/* Login side */}
      <div className="flex-1 relative flex flex-col items-center justify-center px-6 pt-20 pb-10 md:p-12">
        <ThemeToggle className="absolute top-4 right-4" />
        <LoginForm />
        <p className="mt-8 label-caps text-ink-faint text-center max-w-sm leading-relaxed">
          Access is restricted to invited providers — use the unique link sent to you
        </p>
      </div>
    </div>
  );
};
